export class NotificationState {
    notificationTypes = [];
    totalNotRead: number = 0;
    notReadList = [];
    updateNotifications = [];
    updateNotifications_length: number = 0;
    updateDistinctDevices = [];
    securityNotifications = [];
    securityNotifications_length: number = 0;
    securityDistinctDevices = [];
    oneTimeCodeNotifications = [];
    oneTimeCodeNotifications_length: number = 0;
    oneTimeCodeDistinctDevices = [];
    currentFilter = null;
    currentOptions = null;

    constructor() {}
}

export default new NotificationState();
